import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    ClientSetting,
    CreateClientSettingInput,
    DeleteClientSettingInput,
    UpdateClientSettingInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class ClientSettingService {
    private amplifyClient = generateClient();

    constructor() {}

    async listClientSettings(): Promise<ClientSetting[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listClientSettings
                })
            ).data.listClientSettings.items;
            if (data) return data as ClientSetting[];
        } catch (error) {
            console.error('Error finding ClientSetting:', error);
            return null;
        }
    }

    async getClientSetting(id: string): Promise<ClientSetting> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getClientSetting,
                    variables: {
                        id
                    }
                })
            ).data.getClientSetting;
            if (data) return data as ClientSetting;
        } catch (error) {
            console.error('Error finding Clients:', error);
            return null;
        }
    }

    async createClientSetting(
        input: CreateClientSettingInput
    ): Promise<ClientSetting> {
        try {
            const ClientSetting = (
                await this.amplifyClient.graphql({
                    query: mutations.createClientSetting,
                    variables: {
                        input
                    }
                })
            ).data.createClientSetting;
            if (ClientSetting) return ClientSetting as ClientSetting;
        } catch (error) {
            console.error('Error creating ClientSetting:', error);
            return null;
        }
    }

    async updateClientSetting(
        input: UpdateClientSettingInput
    ): Promise<ClientSetting> {
        try {
            const ClientSetting = (
                await this.amplifyClient.graphql({
                    query: mutations.updateClientSetting,
                    variables: {
                        input
                    }
                })
            ).data.updateClientSetting;
            if (ClientSetting) return ClientSetting as ClientSetting;
        } catch (error) {
            console.error('Error updating ClientSetting:', error);
            return null;
        }
    }

    async deleteClientSetting(
        input: DeleteClientSettingInput
    ): Promise<ClientSetting> {
        try {
            const deleteClient = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteClientSetting,
                    variables: {
                        input
                    }
                })
            ).data.deleteClientSetting;
            return deleteClient as ClientSetting;
        } catch {
            console.error('Error deleted ClientSetting:', Error);
            return null;
        }
    }

    async getClientSettingByDomain(
        domain: string
    ): Promise<ClientSetting | null> {
        try {
            const response: any = await this.amplifyClient.graphql({
                query: queries.ListClientSettingsByDomain,
                variables: { domain }
            });
            const items = response?.data?.ListClientSettingsByDomain?.items;
            if (!items || items.length === 0) {
                return null;
            }
            return items[0] as ClientSetting;
        } catch (error) {
            console.error('Error getting ClientSetting by domain:', error);
            return null;
        }
    }
}
